import React, { useState, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';

import Status from './Status';
import ChallengeBox from './ChallengeBox';
import AddressDetails from './AddressDetails';
import QuickLinks from './QuickLinks';
import './styles.css';

const breakpoint = 1024;
const desktopBreakpoint = 1200;

const MyBox = ({
  data, screenMode, isChallenge, hasFailed, showReviewButton,
}) => {
  const {
    imageURL,
    name,
    status = {
      id: '',
      title: '',
      body: '',
      trackingUrl: '',
    },
    shippingAddress,
    order,
  } = data;

  const [windowSize, setWindowSize] = useState({ width: window.innerWidth });
  const isMobile = windowSize.width < breakpoint;
  const isTablet = window.innerWidth >= breakpoint && window.innerWidth <= desktopBreakpoint;
  const handleResize = () => {
    setWindowSize({ width: window.innerWidth });
  };
  useLayoutEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [windowSize]);

  return isChallenge
    && (data && data.order) ? (
      <ChallengeBox
        imageURL={imageURL}
        name={name}
        id={status.id}
        title={status.title}
        body={status.body}
        trackingUrl={status.trackingUrl}
        order={order}
        shippingAddress={shippingAddress}
        isMobile={isMobile}
        isTablet={isTablet}
        isChallenge={isChallenge}
        screenMode={screenMode}
        hasFailed={hasFailed}
        showReviewButton={showReviewButton}
      />
    ) : (
      <>
        <section className="mybox-container">
          <Status
            imageURL={imageURL}
            name={name}
            id={status.id}
            title={status.title}
            body={status.body}
            trackingUrl={status.trackingUrl}
            showReviewButton={showReviewButton}
            hasFailed={hasFailed}
            isMobile={isMobile}
          />
          <AddressDetails
            isChallenge={isChallenge}
            shippingAddress={shippingAddress}
            hasFailed={hasFailed}
            boxStatusId={status.id}
          />
          <QuickLinks statusId={status.id} isChallenge={isChallenge} />
        </section>
        <div className="divider" />
      </>
    );
};

MyBox.defaultProps = {
  screenMode: 'mobile',
  data: {
    id: null,
    imageURL: '',
    name: '',
    status: {
      id: '',
      title: '',
      body: '',
      trackingUrl: '',
    },
    order: {
      currentOrderStep: '',
      orderSteps: [
        {
          label: '',
          message: '',
          order: null,
        },
      ],
    },
    shippingAddress: {
      address1: '',
      address2: '',
      city: '',
      state: '',
      postalCode: '',
      country: '',
      userName: '',
    },
    surveyFinished: true,
    surveyStarted: false,
    eligible: false,
  },
  isChallenge: false,
  hasFailed: false,
  showReviewButton: false,
};

MyBox.propTypes = {
  screenMode: PropTypes.string,
  data: PropTypes.shape({
    id: PropTypes.number,
    imageURL: PropTypes.string,
    name: PropTypes.string,
    status: PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      body: PropTypes.string,
      trackingUrl: PropTypes.string,
    }),
    order: PropTypes.shape({
      currentOrderStep: PropTypes.string,
      orderSteps: PropTypes.arrayOf(
        PropTypes.shape({
          label: PropTypes.string,
          message: PropTypes.string,
          order: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
      ),
    }),
    shippingAddress: PropTypes.shape({
      address1: PropTypes.string,
      address2: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      postalCode: PropTypes.string,
      country: PropTypes.string,
      userName: PropTypes.string,
    }),
    surveyFinished: PropTypes.bool,
    surveyStarted: PropTypes.bool,
    eligible: PropTypes.bool,
  }),
  isChallenge: PropTypes.bool,
  hasFailed: PropTypes.bool,
  showReviewButton: PropTypes.bool,
};

export default MyBox;
